import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export async function submitDiagnostic(payload) {
  const { data } = await api.post("/diagnostic", payload);
  return data;
}

export async function submitCareer(payload) {
  const { data } = await api.post("/careers", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function requestDownloadLink(email, slug) {
  const { data } = await api.post("/publications/download-link", { email, slug });
  return data;
}
